<template>

    <div class="welcome">

        <div class="welcome-text">
            <p>
                <b>{{ $t('txtWelcome') }}</b>{{ $t('txtWelcome1') }}                
                <br /><br />
                {{ $t('txtWelcome2') }}
                <br /><br />
                {{ $t('txtWelcome3') }}
            </p>    

        </div>

        <div class="welcome-img">
            <img alt="Yoga By Ian" src="../../assets/palolem/palolem-0.2.png">
        </div>

    </div>

</template>
  
<script>

    export default {
        name: 'WelcomeHeader',
        
    methods: {
    },

    components: {
        
    }
    }

</script>

<style>

    .welcome {
        width: 98%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        flex-wrap: wrap;
        padding-left: 10px;
        padding-bottom: 10px;
    }

    .welcome-text {
        flex: 1 1 380px;
        font-size: 18px;
        text-align: left;
        padding-top: 0px;
        padding-left: 20px;
        padding-right: 40px;
    }

    .welcome-img {
        width:240px;
        margin-right: 30px;  
    }

    @media screen and (max-width: 600px) {

        .welcome {
            flex-wrap: wrap;
        }
            
        .welcome-img {
            justify-content: center;
        }
        
        .welcome-text {
            font-size: 14px;
            text-align: left;
            padding-top: 0px;
            padding-left: 0px;
            padding-right: 20px;
        }
    }

</style>
